import { Application } from '@hotwired/stimulus';
import { definitions } from 'stimulus:.';

const app = Application.start();
app.load(definitions);
